<template>
	<div class="display-flex flex-column justify-content-center align-items-center">
		<component :is="iconComponent" class="icon ink-lighter-2"></component>
		<div class="empty-state align-center">
			<h2 class="extra-bold font-size-big ink-base margin-top-big">
				{{ title }}
			</h2>
			<p class="font-size-normal ink-lighter-2 margin-vertical-big">
				{{ description }}
			</p>
			<slot name="emptyStateAction"></slot>
		</div>
	</div>
</template>

<script>
import { BIcon } from '@bossabox-code/design-system';
import * as icons from '@bossabox-code/design-system/components/new_icons';

export default {
	name: 'b-empty-state',
	components: {
		BIcon
	},
	props: {
		/**
		 * Nome do ícone a ser exibido. Este nome deve ser o mesmo
		 * existente na exportação de ícones do arquivo new_icons/index.js.
		 */
		icon: {
			type: String,
			required: true
		},
		/**
		 * Título do empty state.
		 */
		title: {
			type: String,
			required: true
		},
		/**
		 * Descrição do que apareceria na página, caso ela não fosse um empty state.
		 */
		description: {
			type: String,
			required: true
		}
	},
	computed: {
		iconComponent() {
			return icons[this.icon];
		}
	}
};
</script>

<style scoped lang="scss">
@import '@bossabox-code/design-system/css/_variables.scss';

.empty-state {
	max-width: 33.2rem;
}

.icon {
	font-size: 8rem;
}
</style>
